package com.example.mystybag.common.helpers

import androidx.compose.ui.text.input.OffsetMapping
import com.example.mystybag.common.resources.SR
import com.example.mystybag.core.defines.TextFieldType
import com.example.mystybag.core.defines.UtilsTransfersDefines.ADDRESS_MAX_LENGTH
import com.example.mystybag.core.defines.UtilsTransfersDefines.CITY_MAX_LENGTH
import com.example.mystybag.core.defines.UtilsTransfersDefines.CYRILLIC_PART_IN_PATTERN
import com.example.mystybag.core.defines.UtilsTransfersDefines.CYRILLIC_PATTERN
import com.example.mystybag.core.defines.UtilsTransfersDefines.EMAIL_LENGTH
import com.example.mystybag.core.defines.UtilsTransfersDefines.EMAIL_SYMBOLS_PATTERN
import com.example.mystybag.core.defines.UtilsTransfersDefines.LATIN_CYRILLIC_NUMBERS
import com.example.mystybag.core.defines.UtilsTransfersDefines.NAME_MAX_LENGTH
import com.example.mystybag.core.defines.UtilsTransfersDefines.ONLY_NUMBERS_PATTERN
import com.example.mystybag.core.defines.UtilsTransfersDefines.PHONE_INPUT
import com.example.mystybag.core.defines.UtilsTransfersDefines.PHONE_MAX_LENGTH
import com.example.mystybag.core.defines.UtilsTransfersDefines.POSTAL_CODE_MAX_LENGTH
import com.example.mystybag.core.expected.sharedString
import com.example.mystybag.core.extensions.equalsIgnoreCase
import com.example.mystybag.core.logic.base.AppViewModel
import com.example.mystybag.core.model.SnackbarConfig

object UtilsTransfersMethods {
    private fun getTextFieldRegex(type: TextFieldType) =
        when (type) {
            TextFieldType.POSTAL_CODE,
            TextFieldType.CITY,
            TextFieldType.ADDRESS,
            TextFieldType.NAME,
            TextFieldType.CITY_BG,
            TextFieldType.ADDRESS_BG -> LATIN_CYRILLIC_NUMBERS

            TextFieldType.POSTAL_CODE_BG -> ONLY_NUMBERS_PATTERN
            TextFieldType.PHONE -> PHONE_INPUT
            TextFieldType.EMAIL -> EMAIL_SYMBOLS_PATTERN
            else -> ""
        }.toRegex()

    private fun getTextFieldMaxLength(type: TextFieldType) =
        when (type) {
            TextFieldType.ANY -> Int.MAX_VALUE
            TextFieldType.CITY,
            TextFieldType.CITY_BG -> CITY_MAX_LENGTH

            TextFieldType.POSTAL_CODE_BG,
            TextFieldType.POSTAL_CODE -> POSTAL_CODE_MAX_LENGTH

            TextFieldType.ADDRESS_BG,
            TextFieldType.ADDRESS -> ADDRESS_MAX_LENGTH

            TextFieldType.NAME -> NAME_MAX_LENGTH
            TextFieldType.PHONE -> PHONE_MAX_LENGTH
            TextFieldType.EMAIL -> EMAIL_LENGTH
            else -> 0
        }

    fun validateTextInput(fieldType: TextFieldType, text: String): String {
        val regex       = getTextFieldRegex(fieldType)
        val newText     = text.replace(regex, "").replace("  ", " ").let { if (fieldType == TextFieldType.NAME) it.uppercase() else if (it.startsWith(" ")) it.replaceFirst(" ", "") else it }
        val maxLength   = getTextFieldMaxLength(fieldType)

        if (newText.length > maxLength) {
            AppViewModel.showSnackbar(SnackbarConfig(sharedString(SR.strings.you_have_reached_the_maximum_number_of_characters)))
            return newText.take(maxLength).trim()
        }
        else if (regex.pattern.isNotBlank() && !regex.toString().contains(CYRILLIC_PART_IN_PATTERN) && CYRILLIC_PATTERN.toRegex().containsMatchIn(text))
            AppViewModel.showSnackbar(SnackbarConfig(sharedString(SR.strings.please_use_only_latin_letters)))
        else if (!text.equalsIgnoreCase(newText))
            AppViewModel.showSnackbar(SnackbarConfig(sharedString(if (regex.toString() == ONLY_NUMBERS_PATTERN) SR.strings.not_allowed_symbol_please_use_only_numbers else SR.strings.not_allowed_symbol)))
        return newText
    }

    object PanOffsetMapping: OffsetMapping {
        override fun originalToTransformed(offset: Int): Int {
            if (offset <= 4) return offset
            if (offset <= 8) return offset + 1
            if (offset <= 12) return offset + 2
            if (offset <= 16) return offset + 3
            return 19
        }

        override fun transformedToOriginal(offset: Int): Int {
            if (offset <= 4) return offset
            if (offset <= 9) return offset - 1
            if (offset <= 14) return offset - 2
            if (offset <= 19) return offset - 3
            return 16
        }
    }
}